import React from 'react'

import { t } from 'i18n'
import { Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ProPlanImage from 'images/green-checkmark-circle.png'
import { commonStyles } from './common'
import Button from 'components/button'
// import { markGateCompleted } from 'components/gates'

const useStyles = makeStyles((theme) => ({
  ...commonStyles(theme),
  container: {
    textAlign: 'center'
  },
  description: {
    color: theme.palette.inputs.label.color.light,
    marginTop: theme.spacing(3)
  },
  link: {
    display: 'inline-block'
  }
}))

const CompletedForm: React.FC<{}> = () => {
  const classes = useStyles()

  const handleTakeALook = () => {
    window.location.assign('/complete_sign_up/open_subdomain')
  }

  // const handleSkip = () => {
  //   markGateCompleted('onboarding')
  //   window.location.assign('/complete_sign_up/open_subdomain')
  // }

  return (
    <Grid container direction='column' className={classes.container}>
      <Grid item>
        <img src={ProPlanImage} className={classes.icon} />
      </Grid>
      <Typography component='h2' variant='h2' className={classes.title}>
        {t('sign_up.completed_form.title')}
      </Typography>
      <Typography component='p' className={classes.description}>
        {t('sign_up.completed_form.description')}
      </Typography>
      <Grid item container justifyContent='center' alignItems='center' spacing={4}>
        <Grid item>
          <Button variant='contained' color='primary' className={classes.submit} size='large' onClick={handleTakeALook}>
            {t('sign_up.completed_form.take_a_look')}
          </Button>
        </Grid>
        {/* <Grid item>
          <a className={clsx(classes.submit, classes.link)} onClick={handleSkip}>
            {t('sign_up.completed_form.skip')}
          </a>
        </Grid> */}
      </Grid>
    </Grid>
  )
}

export default CompletedForm
